/** File extensions reserved for the image upload flow — rendered as thumbnails by the chat UIs. */
const IMAGE_FILE_PATTERN = /\.(jpe?g|png|webp)$/i;

export const IMAGE_EXTENSIONS_ACCEPT_ATTR = ".jpg,.jpeg,.png,.webp";

export const isImageFile = (fileName: string, contentType?: string): boolean =>
  contentType?.toLowerCase().startsWith("image/") ||
  IMAGE_FILE_PATTERN.test(fileName);
